import { useContext } from 'react'
import { Form, Select, Skeleton } from 'antd'
import { ClearOutlined, FilterOutlined } from '@ant-design/icons'
import { UtilsContext } from '@BUP/contexts/utils-context'
import ButtonComponent from '../Generics/Buttons/button-component'
import CollapsePanel from '../Generics/CollapsePanel'
import { useTranslation } from 'react-i18next'
import styles from './filter-complaints.module.scss'
import { FilteredComplaintsContext } from '@BUP/contexts/filtered-complaints-context'

export const FilterComplaints = () => {
  const i18n = useTranslation()
  const { data: dataUtils, isLoading: isLoadingUtils } = useContext(UtilsContext)
  const { filters, setFilters } = useContext(FilteredComplaintsContext)

  if (!dataUtils) return null
  const { complaint: complaintUtils } = dataUtils
  const { infractionLevels, infractionTypes, next_steps: nextStep, protocol_type: protocolType, states } = complaintUtils

  const filterOptions = {
    infractionType: {
      value: infractionTypes,
      name: 'infraction-type'
    },
    infractionLevel: {
      value: infractionLevels,
      name: 'infraction-level'
    },
    nextStep: {
      value: nextStep,
      name: 'next-steps'
    },
    state: {
      value: states,
      name: 'state'
    },
    protocolType: {
      value: protocolType,
      name: 'protocol-type'
    }
  }

  const hasActiveFilters = Object.values(filters).some(filter => filter.length > 0)

  const clearFilters = (event) => {
    event.stopPropagation()
    setFilters({
      infractionType: [],
      infractionLevel: [],
      nextStep: [],
      state: [],
      protocolType: []
    })
  }

  return (
    <Skeleton active loading={isLoadingUtils}>
      <div className={styles.collapse_wrapper}>
        <CollapsePanel
          label={
            <div className={styles.filter_label_collapse_wrapper}>
              <div className={styles.filter_label_text}>
                <span><FilterOutlined /></span><strong>Filtrar por categoría</strong>
              </div>
              {hasActiveFilters && (
                <div className={styles.button_container}>
                  <ButtonComponent
                    buttonText='Limpiar filtros'
                    shape='square'
                    onClick={(e) => clearFilters(e)}
                    icon={<ClearOutlined />}
                    colorType='tertiary'
                  />
                </div>
              )}
            </div>
            }
          shadow
          isOpenCollapse
        >
          <div className={styles.filters_container}>
            <Form layout='vertical'>
              <div className={styles.selects_wrapper}>
                {Object.keys(filterOptions).map(filterKey => (
                  <Form.Item
                    key={filterKey}
                    label={i18n.t(`common.resources.complaint.attributes.${filterOptions[filterKey].name}.label`)}
                    className={styles.filter_item}
                  >
                    <div id='areaSelect'>
                      <Select
                        mode='multiple'
                        style={{ width: '100%' }}
                        placeholder={i18n.t(`common.resources.complaint.attributes.${filterOptions[filterKey].name}.label`)}
                        options={filterOptions[filterKey].value.map(option => ({
                          value: option,
                          label: i18n.t(`common.resources.complaint.values.${filterOptions[filterKey].name}.${option}.label`, option)
                        }))}
                        value={filters[filterKey]}
                        onChange={selectedValues => setFilters(prev => ({ ...prev, [filterKey]: selectedValues }))}
                        getPopupContainer={() => document.getElementById('areaSelect')}

                      />
                    </div>
                  </Form.Item>
                ))}
              </div>
            </Form>
          </div>
        </CollapsePanel>
      </div>
    </Skeleton>
  )
}
